import { useEffect, useState } from 'react';
import config from '@/config';

interface BrowserInfo {
  name: string;
  version: string;
  isSupported: boolean;
}

const extractVersion = (userAgent: string, browser: string): string => {
  const match = userAgent.match(new RegExp(`${browser}[/\\s](\\d+)`, 'i'));
  return match ? match[1] : '0';
};

export function useBrowserSupport() {
  const [ browserInfo, setBrowserInfo ] = useState<BrowserInfo>({
    name: 'Unknown',
    version: '0',
    isSupported: false
  });
  const [ isLoading, setIsLoading ] = useState(true);
  const [ error, setError ] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      const userAgent = navigator.userAgent.toLowerCase();
      const browserName = userAgent.includes('firefox') ? 'Firefox' : 'Chrome';
      try {
        const response = await fetch(`${config.baseUrl}/${config.endpoints.browserCheck}`);
        if (!response.ok) {
          const errorData = await response.json();
          if (errorData.status === 'error' && errorData.payload?.errorCode === 'browser_not_supported') {
            // Handle browser not supported
            setBrowserInfo({
              name: browserName,
              version: extractVersion(userAgent, browserName.toLowerCase()),
              isSupported: false
            });
          } else {
            setBrowserInfo({
              name: browserName,
              version: extractVersion(userAgent, browserName.toLowerCase()),
              isSupported: true
            });
            setError('Something went wrong');
          }
        } else {
          setBrowserInfo({
            name: browserName,
            version: extractVersion(userAgent, browserName.toLowerCase()),
            isSupported: true
          });
        }
      } catch (e) {
        console.error('Failed to fetch base URL:', e);
        setError('Failed to fetch base URL');
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  return { browserInfo, isLoading, error };
}
